export default {
      id: "oc-theme-setting-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite.svg#oc-theme-setting",
      toString: function () {
        return this.url;
      }
    }